export default import.meta.ROLLUP_FILE_URL_$lw1cZVZm_dsLRp5ywdmfQ